module.exports = "../fonts/hotel_additional_services_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hotel_additional_services_icon.svg
// module id = 438
// module chunks = 0